const React = require('react');
const SharedModels = require('../../../../shared/sharedModels');
const MultiLineTextField = require('./commonControls.jsx.js').MultiLineTextField;
const Toastr = require('toastr');
const AjaxFunctions = require('../ajaxFunctions.js');
const ReduxStore = require('../redux/reduxStore.jsx.js');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const PropTypes = require('prop-types');
const LocalStorage = require('../localStorage.js');
const Link = require('react-router-dom').Link;
const Utils = require('../utils');
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';

const SharedConstants = require('../../../../shared/sharedConstants');


import Button from '@material-ui/core/Button';

class ConjectureCreationBase extends React.Component {
   constructor(props) {
      super(props);
      let savedState = null;
      try {
         savedState = JSON.parse(LocalStorage.getItem('conjectureCreationState'));
      }
      catch (e) {
         console.log('could not load saved conjecture creation state');
      }
      if (savedState) {
         this.state = savedState;
         if (savedState.evidenceToLink) {
            for (let evidence of savedState.evidenceToLink) {
               this.props.addToCreation(evidence);
            }
         }
      }
      else {
         this.state = {
            enteredText: '',
            isWaitingOnSubmit: false,
            submitButtonText: 'Submit',
            tags: '',
         }
      }
      this.state.curUserSelection = [];
   }

   async componentDidMount() {
      this.props.setShowLinkBtn(true);
   }

   clearCardInput() {
      document.getElementById('cardCreationConjectureSynopsis').value = '';
      document.getElementById('cardCreationConjectureTags').value = '';

      this.props.setEvidence([]);

      this.setState({
         enteredText: '',
         tags: '',
         evidenceToLink: [],
         curUserSelection: [],
      });

      let toSaveState = { ...this.state };
      LocalStorage.setItem('conjectureCreationState', JSON.stringify(toSaveState));
   }

   createConjecture() {
      if (!this.isCardValid()) {
         return;
      }

      if (!window.globals.idUser) {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error('Only Registered Users Can Create Conjecture.');
         document.getElementById('btnNavBarSignIn').click();
         return;
      }
      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.removeCard("card_placeholder"));
      this.setState({ isWaitingOnSubmit: true, submitButtonText: 'Creating. . .' });

      let card = {
         title: this.state.enteredText,
         idEvidenceCard1: parseInt(this.props.evidenceToLink[0].id),
         idEvidenceCard2: parseInt(this.props.evidenceToLink[1].id),
         isPrivate: false,
         userSelection: [],

      };

      if (this.state.tags.trim().length > 0) {
         let rawTags = this.state.tags.trim().toLowerCase().split(' ');
         let tags = [];
         for (let tag of rawTags) {
            tags.push(new SharedModels.Tag({ text: tag }));
         }
         card.tags = tags;
      }

      for (let usr of this.state.curUserSelection) {
         card.userSelection.push(usr.value);
      }


      AjaxFunctions.createReasoningCard(card).then((res) => {
         this.setState({ isWaitingOnSubmit: false, submitButtonText: 'Submit' });
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.success('Added Conjecture.');

         //cardSet will be a prop rather than rely on the redux store here.
         /*ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.addCard(new SharedModels.GreySpaceCard({
            idGreySpaceCard: res.idGreySpaceCard,
            title: card.title,
            isPrivate: true,
            evidenceCard1: ReduxStore.getEvidenceCardByID(card.idEvidenceCard1),
            evidenceCard2: ReduxStore.getEvidenceCardByID(card.idEvidenceCard2),
         })));*/

         this.clearCardInput();
         Utils.updateCurrentUserData();
      })
   }

   isCardValid() {
      return this.state.enteredText.trim().length > 1
         && !this.state.isWaitingOnSubmit
         && this.props.evidenceToLink.length === 2;
   }

   onCancel() {
      this.props.setShowLinkBtn(false);
      this.props.onCancel();
   }

   onFieldChange(stateKey, stateValue) {
      this.setState({ [stateKey]: stateValue }, () => {
         let toSaveState = { ...this.state };
         toSaveState.evidenceToLink = this.props.evidenceToLink;
         LocalStorage.setItem('conjectureCreationState', JSON.stringify(toSaveState));
      })
   }

   onUserSelectionChanged(curUserSelection) {
      this.setState({ curUserSelection });
   }

   render() {
      let instructions = '';
      if (this.props.evidenceToLink.length === 0) {
         instructions = 'Select two Evidence ' + String.fromCharCode(181) + 'Pubs by pressing the \'Create Link\' Button, then dragging two Evidence ' + String.fromCharCode(181) +
            'Pubs together.';
      }
      else if (this.props.evidenceToLink.length === 1) {
         instructions = 'Select one more ' + String.fromCharCode(181) + 'Pub from the list. Click Link next to ' +
            'any of the Evidence ' + String.fromCharCode(181) + 'Pubs to populate boxes 1 and 2';
      }
      else {
         instructions = 'Next, let us know how you think your selected evidence is related, to pick different ' + String.fromCharCode(181)
            + 'Pubs, click the "Clear Form" button below.';
      }

      let allUserOptions = [];
      if (this.state.curUserSelection.length < 3) {
         for (let option of this.props.userSocialNetwork.followers) {
            allUserOptions.push({ value: option.idUser, label: `${option.firstName} ${option.lastName}` });
         }
         for (let option of this.props.userSocialNetwork.followees) {
            allUserOptions.push({ value: option.idUser, label: `${option.firstName} ${option.lastName}` });
         }
      }

      allUserOptions = Utils.removeDuplicatesFromArrayByProp(allUserOptions, 'value');
      return (
         <div id='conjectureCreationContainer'>
            <fieldset className='form__container'>
               <div>
                  <Link to={'/listView'}>
                     <i
                        id='btnCancelCreation'
                        className='fa fa-times float-right'
                        onClick={() => this.onCancel()}
                     />
                  </Link>
                  <h1 className='form__header'>{this.props.headerText}</h1>
               </div>
               <div id='conjectureCreationInstructions'>
                  {this.props.enableAdd? instructions : this.props.subHeaderText}
               </div>
              { <EvidencePreview
                  evidence1={this.props.evidenceToLink[0] || {}}
                  evidence2={this.props.evidenceToLink[1] || {}}
                  removeFunction={(id) => this.props.removeFromCreation(id)}
               />}
               {(this.props.enableAdd && this.props.evidenceToLink[0] && this.props.evidenceToLink[1] && this.props.evidenceToLink[0].id && this.props.evidenceToLink[1].id) &&
                  <div>
                     <MultiLineTextField
                        idInput='cardCreationConjectureSynopsis'
                        data={this.state.enteredText}
                        onChange={(event) => this.onFieldChange('enteredText', event.target.value)}
                        dataField=''
                        checkForValidationErrors={false}
                        placeholder={'Summarize in a question or statement how these two Evidence µPubs could result in a new idea to investigate.'}
                        maxLength='250'
                        label='Summary'
                        InputLabelProps={{
                           shrink: true,
                        }}
                     />
                     <label htmlFor='cardCreationConjectureTags'>Keywords</label>
                     <input
                        id='cardCreationConjectureTags'
                        className='form__input'
                        placeholder={'(Optional) additional tags to describe the Conjecture'}
                        value={this.state.tags}
                        onChange={(event) => this.onFieldChange('tags', event.target.value)}
                        maxLength="300"
                     />

                     <Button
                        color='primary'
                        id='btnCreationClear'
                        onClick={() => {
                           ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.removeCard("card_placeholder"));
                           this.clearCardInput();
                           this.onFieldChange('', '');
                        }}
                     >
                        Clear Selection
               </Button>

                  </div>
               }

            </fieldset>
            {(this.props.evidenceToLink[0] && this.props.evidenceToLink[1] && this.props.evidenceToLink[0].id && this.props.evidenceToLink[1].id) &&
               <input
                  id='btnEvidenceSubmit'
                  className={this.isCardValid() ? 'active' : 'disabled'}
                  type='submit'
                  value={this.state.submitButtonText}
                  onClick={() => {
                     this.createConjecture()
                  }}
               />}

            <SelectedCardData card={this.props.selectedCard} linkBase={this.props.linkBase} />
            <TextField
                     label="µPub Search"
                     placeholder={`Search for ${String.fromCharCode(181)}Pubs`}
                     margin="normal"
                     fullWidth
                     onChange={(event) => {
                        ReduxStore.store.dispatch(ReduxStore.EditorFunctions.setSearchString(event.target.value))
                     }}
                     variant="outlined"
            />
         </div>
      )
   }
}

ConjectureCreationBase.propTypes = {
   allTopics: PropTypes.array,
};

class EvidencePreview extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {
      return (
         <div>
            {(this.props.evidence1.id && this.props.evidence2.id) && <div>
               <Chip label={this.props.evidence1.title} variant="outlined" />
               <i className="fas fa-link" style={{ marginLeft: '1px', marginRight: '2px' }} />
               <Chip label={this.props.evidence2.title} variant="outlined" />
            </div>
            }
         </div>
      );
   }
}


class SelectedCardData extends React.Component {
   constructor(props) {
      super(props);
   }


   render() {
      let card = this.props.card;

      let cardLink = () => {
         if (this.props.linkBase) {
            return (<div style={{marginBottom:'1em'}}>
               <Link to={`${this.props.linkBase}&cardType=${card.cardType}&idCard=${card.id}&cModalOpen=1`}>{card.title}</Link>
            </div>);
         } else {
            return (<div style={{marginBottom:'1em'}}>{card.title}</div>)
         }
      }
      if (card) {
         if (card.cardType === SharedConstants.CardType.Evidence) {
            return (
               <div style={{ padding: '5%' }}>
                  <h2><b><u>{`Evidence µPub:`}</u></b></h2>
                  {<Link to={"/users/profile?idUser=" + card.creator.id} className="post-author">
                     {card.creator.firstName} {card.creator.lastName} {card.creator.points ? `(${card.creator.points} points)` : ``}
                  </Link>
                  }
                  <div className="timestamp" style={{marginBottom:'1em'}}>
                     {card.creationTime ? new Date(card.creationTime).toLocaleDateString() : ''}
                  </div>
                  {cardLink()}
                  <div className={'conjecture-creation-evidence-preview'}>
                     {card.citation}
                  </div>
                  <div className={'conjecture-creation-evidence-preview'}>
                     {card.source}
                  </div>
                  {card.tags.map((tag) => {
                     return (<Chip label={tag} variant="outlined" />
                     )
                  })}
               </div>
            );
         } else {
            return (
               <div style={{ padding: '5%' }}>
                  <h2><b><u>{`Conjecture µPub:`}</u></b></h2>
                  {<Link to={"/users/profile?idUser=" + card.creator.id} className="post-author">
                     {card.creator.firstName} {card.creator.lastName} {card.creator.points ? `(${card.creator.points} points)` : ``}
                  </Link>
                  }
                  <div className="timestamp">
                     {card.creationTime ? new Date(card.creationTime).toLocaleDateString() : ''}
                  </div>
                  {cardLink()}
                  <div className={'conjecture-creation-evidence-preview'}>
                     {card.evidenceCard1.title}
                  </div>
                  <i className="fas fa-link" style={{ marginLeft: '3px', marginRight: '3px' }} />
                  <div className={'conjecture-creation-evidence-preview'}>
                     {card.evidenceCard2.title}
                  </div>
               </div>
            );
         }

      } else {
         return (
            <div>

            </div>
         );
      }

   }
}

const mapConjectureCreationStateToProps = (state) => {
   return {
      userSocialNetwork: state.UserReducer.curUser.socialNetwork,
      evidenceToLink: state.GreySpaceCardReducer.creationEvidence,
   }
};

const mapConjectureCreationDispatchToProps = (dispatch) => {
   return {
      removeFromCreation: (idEvidence) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.removeEvidenceFromCreation(idEvidence));
      },
      addToCreation: (evidence) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.addEvidenceToCreation(evidence));
      },
      setShowLinkBtn: (bVal) => {
         dispatch(ReduxStore.EditorFunctions.setShowLinkBtn(bVal));
      },
      setEvidence: (evidenceArray) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.setCreationEvidence(evidenceArray));
      }
   }
};

export default connect(
   mapConjectureCreationStateToProps,
   mapConjectureCreationDispatchToProps
)(ConjectureCreationBase);

